const PREFIX = "[business-analytics-sdk]";

let enabled = false;

/** Diagnostics are off until init() opts in, so a production bundle stays quiet. */
export function setDebug(value: boolean): void {
	enabled = value;
}

export function log(message: string, ...details: unknown[]): void {
	if (!enabled) return;
	console.log(`${PREFIX} ${message}`, ...details);
}

export function warn(message: string, ...details: unknown[]): void {
	if (!enabled) return;
	console.warn(`${PREFIX} ${message}`, ...details);
}
